export const validateMap = {
    "fromdate": {
        required: true,
        type: "string",
        min: 2,
    },
}